<template>
    <div>
      <b-row>
          <b-col md="4"></b-col>
          <b-col>
              <b-jumbotron
               header="404"
               lead="A página que você esta tentando acessar não foi encontrada."
               bg-variant="default" text-variant="dark" border-variant="dark"
               ></b-jumbotron>
          </b-col>
          <b-col md="4"></b-col>
      </b-row>
    </div>
</template>

<script>
export default {
  name: 'IndexScreen',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
